import React, { useContext } from "react";
import styled from "styled-components";
import StarIcon from "@material-ui/icons/Star";
import ShareIcon from "@material-ui/icons/Share";
import { DashboardContext } from "../../dashboard-context";

const Card = styled.div`
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  flex: 0 0 auto;
  margin: 5px 0px;
  width: 100%;
  overflow: hidden;
`;

const ThumbnailContainer = styled.div`
  position: relative;
`;

const Thumbnail = styled.img`
  background-color: #000;
  display: block;
  height: ${({ large }) => (large ? "320px" : "160px")};
  width: 100%;
  object-fit: ${({ objectFit }) => objectFit};
  transition: ease all 0.2s;

  @media (max-width: 1100px) {
    height: ${({ large }) => (large ? "240px" : "160px")};
  }

  &:hover {
    filter: brightness(0.8);
  }
`;

const TitleSection = styled.div`
  background-color: ${({ theme }) => theme.color.dark};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 39px;
  padding: 0 12px;

  svg {
    color: #efe811;
    font-size: 1.25rem;
    margin-right: 4px;
  }
`;

const Title = styled.h5`
  color: #fff;
  font-size: 0.9rem;
  text-align: center;
  font-weight: 400;
`;

const VideoLength = styled.div`
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;

  span {
    background-color: #000;
    padding: 4px 8px;
    border-radius: 4px;
    margin-left: 4px;
  }
`;

const CopyIcon = styled.span`
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  border-radius: 100px;
  font-size: 0.8rem;
  width: 22px;
  height: 22px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  svg {
    font-size: 0.8rem;
  }
`;

function VideoCard({
  thumbnail,
  title,
  videoUrl,
  handleVideoClick,
  timestamps = [],
  length,
  objectFit = "cover",
  large = false,
  starred = false,
}) {
  const { openSnackbar } = useContext(DashboardContext);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(videoUrl);
    openSnackbar("Link copied to clipboard");
  };

  return (
    <Card>
      <ThumbnailContainer>
        <CopyIcon onClick={handleCopyLink}>
          <ShareIcon />
        </CopyIcon>
        <Thumbnail
          src={thumbnail}
          alt={title}
          objectFit={objectFit}
          large={large}
          onClick={() => {
            handleVideoClick({ videoUrl, timestamps });
          }}
        />
        <VideoLength
          onClick={() => {
            handleVideoClick({ videoUrl, timestamps });
          }}
        >
          {timestamps.length > 0 && <span>CHAPTERS</span>}
          <span>{length}</span>
        </VideoLength>
      </ThumbnailContainer>
      <TitleSection
        onClick={() => {
          handleVideoClick({ videoUrl, timestamps });
        }}
      >
        {starred && <StarIcon />}
        <Title>{title}</Title>
      </TitleSection>
    </Card>
  );
}

export default VideoCard;
